<div class="print-document-pdf-settings p-4">
  <form class="pdf-settings-form">
    <div class="row fields-group mb-4">
      <div class="col-12">
        <h4 class="list-title mb-4">{{ 'printDoc.pdfSettings.section.orientationSize' | translate }}</h4>
        <div class="row">
          <div class="col-md-6">
            <label class="input-label d-block mb-2" for="pdfPageSize">{{ 'printDoc.pdfSettings.size' | translate }}</label>
            <select
              id="pdfPageSize"
              name="pageSize"
              class="form-control"
              [(ngModel)]="pageSize"
              (ngModelChange)="emitChange()">
              <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt.id">{{ opt.labelKey | translate }}</option>
            </select>
            <div *ngIf="pageSize === 'custom'" class="mt-3">
              <label class="input-label d-block mb-2" for="customPageSize">{{ 'printDoc.pdfSettings.pageSize.customDimensions' | translate }}</label>
              <input
                id="customPageSize"
                name="customPageSize"
                type="text"
                class="form-control"
                [(ngModel)]="customPageSize"
                (ngModelChange)="emitChange()"
                placeholder="21cm 15cm">
            </div>
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.orientation' | translate }}</label>
            <div class="btn-group-primary-light btn-group-toggles btn-group-toggles-medium d-inline-flex flex-wrap">
              <button
                type="button"
                *ngFor="let opt of orientationOptions"
                (click)="orientation = opt.id; emitChange()"
                class="btn-group-toggle {{ orientation === opt.id ? 'active' : '' }}">
                {{ opt.labelKey | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row fields-group mb-4">
      <div class="col-12">
        <h4 class="list-title mb-4">{{ 'printDoc.pdfSettings.section.pageMargins' | translate }}</h4>
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-3">
            <label class="input-label d-block mb-2" for="marginTop">{{ 'printDoc.pdfSettings.margin.top' | translate }}</label>
            <select id="marginTop" name="marginTop" class="form-control" [(ngModel)]="marginTop" (ngModelChange)="emitChange()">
              <option *ngFor="let opt of marginOptions" [ngValue]="opt.id">{{ opt.labelKey | translate }}</option>
            </select>
          </div>
          <div class="col-md-6 col-lg-3 mb-3">
            <label class="input-label d-block mb-2" for="marginBottom">{{ 'printDoc.pdfSettings.margin.bottom' | translate }}</label>
            <select id="marginBottom" name="marginBottom" class="form-control" [(ngModel)]="marginBottom" (ngModelChange)="emitChange()">
              <option *ngFor="let opt of marginOptions" [ngValue]="opt.id">{{ opt.labelKey | translate }}</option>
            </select>
          </div>
          <div class="col-md-6 col-lg-3 mb-3">
            <label class="input-label d-block mb-2" for="marginLeft">{{ 'printDoc.pdfSettings.margin.left' | translate }}</label>
            <select id="marginLeft" name="marginLeft" class="form-control" [(ngModel)]="marginLeft" (ngModelChange)="emitChange()">
              <option *ngFor="let opt of marginOptions" [ngValue]="opt.id">{{ opt.labelKey | translate }}</option>
            </select>
          </div>
          <div class="col-md-6 col-lg-3 mb-3">
            <label class="input-label d-block mb-2" for="marginRight">{{ 'printDoc.pdfSettings.margin.right' | translate }}</label>
            <select id="marginRight" name="marginRight" class="form-control" [(ngModel)]="marginRight" (ngModelChange)="emitChange()">
              <option *ngFor="let opt of marginOptions" [ngValue]="opt.id">{{ opt.labelKey | translate }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row fields-group mb-4">
      <div class="col-12">
        <h4 class="list-title mb-1">{{ 'printDoc.pdfSettings.section.watermark' | translate }}</h4>
        <p class="text-muted small mb-3">{{ 'printDoc.pdfSettings.allPages' | translate }}</p>
        <div class="row mb-3">
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.watermark.position' | translate }}</label>
            <div class="mb-2">
              <span class="small text-muted d-block mb-1">{{ 'printDoc.pdfSettings.watermark.vertical' | translate }}</span>
              <div class="btn-group-primary-light btn-group-toggles btn-group-toggles-medium d-inline-flex flex-wrap">
                <button
                  type="button"
                  *ngFor="let opt of watermarkVerticalOptions"
                  (click)="watermarkVertical = opt.id; emitChange()"
                  class="btn-group-toggle {{ watermarkVertical === opt.id ? 'active' : '' }}">
                  {{ opt.labelKey | translate }}
                </button>
              </div>
            </div>
            <div>
              <span class="small text-muted d-block mb-1">{{ 'printDoc.pdfSettings.watermark.horizontal' | translate }}</span>
              <div class="btn-group-primary-light btn-group-toggles btn-group-toggles-medium d-inline-flex flex-wrap">
                <button
                  type="button"
                  *ngFor="let opt of watermarkHorizontalOptions"
                  (click)="watermarkHorizontal = opt.id; emitChange()"
                  class="btn-group-toggle {{ watermarkHorizontal === opt.id ? 'active' : '' }}">
                  {{ opt.labelKey | translate }}
                </button>
              </div>
            </div>
            <div class="mt-3">
              <label class="input-label d-block mb-2" for="watermarkOpacity">{{ 'printDoc.pdfSettings.watermark.opacity' | translate }}</label>
              <input
                id="watermarkOpacity"
                name="watermarkOpacity"
                type="number"
                min="0"
                max="1"
                step="0.01"
                class="form-control"
                [(ngModel)]="watermarkOpacity"
                (ngModelChange)="emitChange()">
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.watermark.content' | translate }}</label>
            <ckeditor
              class="pdf-settings-editor"
              name="watermarkContent"
              [editor]="Editor"
              [config]="config"
              [(ngModel)]="watermarkContent"
              (ngModelChange)="emitChange()">
            </ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="row fields-group mb-4">
      <div class="col-12">
        <h4 class="list-title mb-1">{{ 'printDoc.pdfSettings.section.corners' | translate }}</h4>
        <p class="text-muted small mb-3">{{ 'printDoc.pdfSettings.allPages' | translate }}</p>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.corners.topLeft' | translate }}</label>
            <ckeditor
              class="pdf-settings-editor"
              name="cornerTopLeft"
              [editor]="Editor"
              [config]="config"
              [(ngModel)]="cornerTopLeft"
              (ngModelChange)="emitChange()">
            </ckeditor>
          </div>
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.corners.topRight' | translate }}</label>
            <ckeditor
              class="pdf-settings-editor"
              name="cornerTopRight"
              [editor]="Editor"
              [config]="config"
              [(ngModel)]="cornerTopRight"
              (ngModelChange)="emitChange()">
            </ckeditor>
          </div>
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.corners.bottomLeft' | translate }}</label>
            <ckeditor
              class="pdf-settings-editor"
              name="cornerBottomLeft"
              [editor]="Editor"
              [config]="config"
              [(ngModel)]="cornerBottomLeft"
              (ngModelChange)="emitChange()">
            </ckeditor>
          </div>
          <div class="col-md-6 mb-3">
            <label class="input-label d-block mb-2">{{ 'printDoc.pdfSettings.corners.bottomRight' | translate }}</label>
            <ckeditor
              class="pdf-settings-editor"
              name="cornerBottomRight"
              [editor]="Editor"
              [config]="config"
              [(ngModel)]="cornerBottomRight"
              (ngModelChange)="emitChange()">
            </ckeditor>
          </div>
        </div>
      </div>
    </div>

    <div class="row fields-group mb-2">
      <div class="col-12">
        <h4 class="list-title mb-1">{{ 'printDoc.pdfSettings.section.headerFooter' | translate }}</h4>
        <p class="text-muted small mb-3">{{ 'printDoc.pdfSettings.headerFooter.optional' | translate }}</p>

        <div class="mb-4">
          <h5 class="input-label mb-2">{{ 'printDoc.pdfSettings.pageHeader' | translate }}</h5>
          <div class="custom-control custom-checkbox mb-3">
            <input
              type="checkbox"
              class="custom-control-input cursor-pointer"
              id="showHeader"
              name="showHeader"
              [(ngModel)]="showHeader"
              (ngModelChange)="onShowHeaderChange($event)">
            <label class="custom-control-label cursor-pointer" for="showHeader">{{ 'printDoc.pdfSettings.showHeader' | translate }}</label>
          </div>
          <div *ngIf="showHeader && headerWidths.length" class="pdf-column-row">
            <div class="pdf-column-flex d-flex flex-row align-items-stretch w-100">
              <ng-container *ngFor="let w of headerWidths; let i = index; let last = last; trackBy: trackByIndex">
                <div class="pdf-column-cell d-flex flex-column min-w-0" [style.flex]="columnFlexBasis(w)">
                  <div class="d-flex justify-content-between align-items-center mb-2 flex-shrink-0">
                    <label class="input-label mb-0">{{ 'printDoc.pdfSettings.headerFooter.columnLabel' | translate: { index: i + 1 } }}</label>
                    <button
                      *ngIf="headerWidths.length > 1"
                      type="button"
                      class="btn btn-link btn-sm p-0 ml-2 pdf-column-remove"
                      (click)="removeHeaderColumn(i)"
                      [attr.aria-label]="'printDoc.pdfSettings.headerFooter.removeColumn' | translate">
                      <i class="fal fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                  <ckeditor
                    class="pdf-settings-editor flex-grow-1"
                    [name]="'headerCol' + i"
                    [editor]="Editor"
                    [config]="config"
                    [(ngModel)]="headerContents[i]"
                    (ngModelChange)="emitChange()">
                  </ckeditor>
                </div>
                <div
                  *ngIf="!last"
                  class="pdf-column-separator flex-shrink-0"
                  role="separator"
                  [attr.aria-label]="'printDoc.pdfSettings.headerFooter.resizeSeparator' | translate"
                  (pointerdown)="onSeparatorPointerDown($event, 'header', i)">
                  <span class="pdf-column-separator-grip"></span>
                </div>
              </ng-container>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary mt-3"
              [disabled]="headerWidths.length >= maxColumns"
              (click)="addHeaderColumn()">
              {{ 'printDoc.pdfSettings.headerFooter.addColumn' | translate }}
            </button>
          </div>
        </div>

        <div class="mb-4">
          <h5 class="input-label mb-2">{{ 'printDoc.pdfSettings.pageFooter' | translate }}</h5>
          <div class="custom-control custom-checkbox mb-3">
            <input
              type="checkbox"
              class="custom-control-input cursor-pointer"
              id="showFooter"
              name="showFooter"
              [(ngModel)]="showFooter"
              (ngModelChange)="onShowFooterChange($event)">
            <label class="custom-control-label cursor-pointer" for="showFooter">{{ 'printDoc.pdfSettings.showFooter' | translate }}</label>
          </div>
          <div *ngIf="showFooter && footerWidths.length" class="pdf-column-row">
            <div class="pdf-column-flex d-flex flex-row align-items-stretch w-100">
              <ng-container *ngFor="let w of footerWidths; let i = index; let last = last; trackBy: trackByIndex">
                <div class="pdf-column-cell d-flex flex-column min-w-0" [style.flex]="columnFlexBasis(w)">
                  <div class="d-flex justify-content-between align-items-center mb-2 flex-shrink-0">
                    <label class="input-label mb-0">{{ 'printDoc.pdfSettings.headerFooter.columnLabel' | translate: { index: i + 1 } }}</label>
                    <button
                      *ngIf="footerWidths.length > 1"
                      type="button"
                      class="btn btn-link btn-sm p-0 ml-2 pdf-column-remove"
                      (click)="removeFooterColumn(i)"
                      [attr.aria-label]="'printDoc.pdfSettings.headerFooter.removeColumn' | translate">
                      <i class="fal fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                  <ckeditor
                    class="pdf-settings-editor flex-grow-1"
                    [name]="'footerCol' + i"
                    [editor]="Editor"
                    [config]="config"
                    [(ngModel)]="footerContents[i]"
                    (ngModelChange)="emitChange()">
                  </ckeditor>
                </div>
                <div
                  *ngIf="!last"
                  class="pdf-column-separator flex-shrink-0"
                  role="separator"
                  [attr.aria-label]="'printDoc.pdfSettings.headerFooter.resizeSeparator' | translate"
                  (pointerdown)="onSeparatorPointerDown($event, 'footer', i)">
                  <span class="pdf-column-separator-grip"></span>
                </div>
              </ng-container>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary mt-3"
              [disabled]="footerWidths.length >= maxColumns"
              (click)="addFooterColumn()">
              {{ 'printDoc.pdfSettings.headerFooter.addColumn' | translate }}
            </button>
          </div>
        </div>

        <div class="border-top pt-2 mt-2">
          <h5 class="input-label mb-2">{{ 'printDoc.pdfSettings.section.pageCount' | translate }}</h5>
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input cursor-pointer"
              id="showPageCount"
              name="showPageCount"
              [(ngModel)]="showPageCount"
              (ngModelChange)="emitChange()">
            <label class="custom-control-label cursor-pointer" for="showPageCount">{{ 'printDoc.pdfSettings.pageCount.show' | translate }}</label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
